var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.4516328,7.05325847 L13.9473494,2.548975 L15.3171352,1.17918921 C15.7078677,0.788456643 16.3342167,0.781302959 16.7284134,1.17549961 L19.8251082,4.27219449 C20.2138031,4.66088934 20.2082032,5.29668811 19.8214186,5.68347267 L18.4516328,7.05325847 Z M17.5507762,7.95411516 L7.01605214,18.4888392 L2.51176868,13.9845557 L13.0464927,3.4498317 L17.5507762,7.95411516 Z M2.51176868,13.9845557 L7.01605214,18.4888392 L2.15699355,20.1085254 L2.15699355,20.1085254 C1.63305023,20.2831731 1.06673025,20.0000132 0.892082482,19.4760698 C0.823660213,19.270803 0.823660213,19.0488811 0.892082482,18.8436143 L2.51176868,13.9845557 Z M3.41262537,14.8854124 L2.51176868,17.5879825 L3.41262537,18.4888392 L6.11519545,17.5879825 L3.41262537,14.8854124 Z"
})))));
export default SvgPencil;